import { createContext } from "react";

const AppSettingsContext = createContext({});

export default AppSettingsContext;
